import React from 'react';
import { Package, Zap, Edit2, Trash2 } from 'lucide-react';

const ItemsList = ({ items, onEditItem, onDeleteItem }) => {
  return (
    <div className="space-y-3">
      {items.map((item, index) => (
        <div key={index} className="bg-white rounded-lg p-4">
          <div className="flex justify-between items-start mb-3">
            <div className="flex items-start gap-3">
              <div className={`p-2 rounded-full ${item.is_lightning_lot ? 'bg-amber-100' : 'bg-green-100'}`}>
                {item.is_lightning_lot ? (
                  <Zap className="w-5 h-5 text-amber-600" />
                ) : (
                  <Package className="w-5 h-5 text-green-600" />
                )}
              </div>
              <div>
                <div className="font-medium">{item.title}</div>
                <div className="text-sm text-gray-500">
                  {item.quantity} × ${item.unitPrice.toLocaleString()}
                </div>
                {item.deposit > 0 && (
                  <div className="text-sm text-gray-500">
                    Seña: ${item.deposit.toLocaleString()} × {item.quantity}
                  </div>
                )}
                {item.is_lightning_lot && (
                  <div className="text-xs text-amber-600 mt-1">
                    Venta relámpago
                  </div>
                )}
              </div>
            </div>
            <div className="text-right">
              <div className="font-medium">${item.subtotal.toLocaleString()}</div>
              {item.totalDeposit > 0 && (
                <div className="text-sm text-gray-500">
                  +${item.totalDeposit.toLocaleString()}
                </div>
              )}
            </div>
          </div>

          {/* Acciones */}
          <div className="flex gap-2">
            <button
              onClick={() => onEditItem(index)}
              className="flex-1 py-2 flex items-center justify-center gap-2 text-blue-600 hover:bg-blue-50 rounded-lg"
            >
              <Edit2 className="w-4 h-4" />
              Editar
            </button>
            <button
              onClick={() => onDeleteItem(index)}
              className="flex-1 py-2 flex items-center justify-center gap-2 text-red-600 hover:bg-red-50 rounded-lg"
            >
              <Trash2 className="w-4 h-4" />
              Eliminar
            </button>
          </div>
        </div>
      ))}

      {items.length === 0 && (
        <div className="text-center text-gray-500 py-8">
          No hay productos agregados
        </div>
      )}
    </div>
  );
};

export default ItemsList; 